// let devices;
// (async () => {   
//     await navigator.mediaDevices.getUserMedia({audio: true, video: false});   
//     devices = await navigator.mediaDevices.enumerateDevices();   
//     console.log(devices); 
//   })();

export async function getMediaDevices(kind) {
    var devList = [];

    await navigator.mediaDevices.getUserMedia({audio: true, video: false});   
    const devices = await navigator.mediaDevices.enumerateDevices();   
    console.log(devices); 

    // If no kind specified, return all devices.
    if (kind === undefined){
        devList = devices;
    }
    else {
        try {
            devList = devices.filter(result => result.kind === kind);
        }
        catch (error) {
            console.error("Failed to list devices of type ${kind}. \n Error: ${error}");
        }
    }

    return devList;
}

export async function getAudioMediaStream(deviceId) {
    if (deviceId === undefined) {
        console.error("Device ID is required for fetching specific MediaStream.");
        return null;
    }

    const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
            deviceId: {
                exact: deviceId
            }
        }
    });

    return stream;
}